import { api } from '../_client';

export const filesAuditApi = {
  // Backfill file hashes for existing flights (admin only)
  async backfillFileHashes(dryRun: boolean = true): Promise<{
    success: boolean;
    message: string;
    total_to_process: number;
    processed: number;
    failed: number;
    failed_details?: Array<{ flight_id: number; s3_key: string; error: string }>;
    duplicates_found: Array<{
      file_hash: string;
      count: number;
      flights: Array<{
        flight_id: number;
        s3_key: string;
        drone_serial?: string;
        flight_date?: string;
      }>;
    }>;
    duplicate_count: number;
    dry_run: boolean;
  }> {
    const response = await api.post(
      `/api/files/backfill-hashes?dry_run=${dryRun}`,
      {},
      {
        timeout: 300000, // 5 minutes timeout for large backfills
      }
    );
    return response.data;
  },

  // Check for duplicate file hashes
  async checkDuplicateHashes(): Promise<{
    success: boolean;
    duplicate_count: number;
    total_duplicate_files: number;
    duplicates: Array<{
      file_hash: string;
      count: number;
      flights: Array<{
        id: number;
        s3_key: string;
        drone_serial?: string;
        flight_date?: string;
      }>;
    }>;
  }> {
    const response = await api.get('/api/files/duplicates');
    return response.data;
  },

  // Audit S3 consistency - find orphaned DB records (admin only)
  async auditS3Consistency(): Promise<{
    success: boolean;
    total_checked: number;
    valid_records: number;
    orphaned_count: number;
    orphaned_records: Array<{ flight_id: string; s3_key: string }>;
  }> {
    const response = await api.post(
      '/api/files/audit-s3-consistency',
      {},
      {
        timeout: 300000, // 5 minutes for large audits
      }
    );
    return response.data;
  },

  // Delete orphaned records - remove DB records where S3 file is missing (admin only)
  async deleteOrphanedRecords(flightIds: string[]): Promise<{
    success: boolean;
    deleted_count: number;
    failed_count: number;
    failed_ids?: string[];
    message: string;
  }> {
    const response = await api.delete('/api/files/orphaned-records', {
      data: { flight_ids: flightIds },
    });
    return response.data;
  },
};
